import React, { ReactNode } from 'react';

export interface IModalTitleProps {
    id?: string;
    children?: ReactNode | ReactNode[];
    shouldHideCloseButton?: boolean;
    onClose?: (evt: React.SyntheticEvent) => void;
}

export function Title(props: IModalTitleProps) {
    const { id } = props;

    const renderCloseButton = () => {
        const { shouldHideCloseButton, onClose } = props;

        if (shouldHideCloseButton) {
            return null;
        }

        return (
            <button type="button" className="modal-close" onClick={(evt: React.SyntheticEvent) => onClose && onClose(evt)} data-testid="modal-close">
                <span className="fs16 fw600">x</span>
            </button>
        );
    };

    return (
        <header className="modal-title" data-testid="modal-title">
            <div id={`modal-title-${id}`}>
                <span className="header">{props.children}</span>
            </div>
            {renderCloseButton()}
        </header>
    );
}
